import { AccountData, DateAvailabilityOut, VoucherOut, WaitingListItemData } from '../../../../api';
import { holdExpiryIso } from '../../../../common/pendingOrderUtils';
import { EditOrderFormValues } from '../EditOrderTypes';

export const getNewParentId = (
  availableDatesForEvents: DateAvailabilityOut[],
  parentId: string | undefined,
  date: string,
  timeSeconds: number,
) => {
  const timeFound = availableDatesForEvents.find((x) => x.date === date)?.times.find((t) => t.seconds === timeSeconds);
  if (timeFound?.eventId && timeFound?.eventId !== parentId) {
    return timeFound.eventId;
  }
  return parentId;
};

export const getCourseId = (availableDatesForEvents: DateAvailabilityOut[], date: string, timeSeconds: number) =>
  availableDatesForEvents.find((x) => x.date === date)?.times.find((t) => t.seconds === timeSeconds)?.courseId;

type CreateOrderPayloadArgs = {
  values: EditOrderFormValues;
  editOrderState: any;
  language: string;
  parentId: string | undefined;
  isEventOrCourse: boolean;
  isCourse: boolean;
  availableDatesForEvents: DateAvailabilityOut[];
  voucherToRedeem?: VoucherOut;
  waitingListItem?: WaitingListItemData;
  account: AccountData;
  depositPrice?: number;
};

export const buildCreateOrderPayload = ({
  values,
  editOrderState,
  language,
  parentId,
  isEventOrCourse,
  isCourse,
  availableDatesForEvents,
  voucherToRedeem,
  waitingListItem,
  account,
  depositPrice,
}: CreateOrderPayloadArgs) => {
  const duration = values.privateOrderEndTimeSeconds - values.timeSeconds;

  return {
    // null (not undefined) is sent for a private order, as before.
    parent_id: (isEventOrCourse
      ? getNewParentId(availableDatesForEvents, parentId, values.date, values.timeSeconds)
      : null) as string | undefined,
    details: {
      ...editOrderState.details,
      duration: isEventOrCourse ? editOrderState.orderPage.duration : duration,
      resource_option_id: values.resourceOptionId,
    },
    date_and_time_details: !isEventOrCourse || isCourse ? { date: values.date, time: values.timeSeconds } : undefined,
    personal_details: {
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      phone: values.phone,
      custom_personal_details: values.custom_personal_details,
      alternative_full_name: values.alternative_full_name,
    },
    order_id: '',
    new_parent_id: '',
    account_id: editOrderState.account.id,
    experience_id: editOrderState.experience.id,
    order_page_id: editOrderState.orderPage.id,
    language,
    employee_ids: values.selectedUsersIds,
    comment: values.comment,
    voucher_id_to_redeem: voucherToRedeem ? voucherToRedeem.id : undefined,
    waitlist_item_id_to_redeem: waitingListItem ? waitingListItem.id : undefined,
    voucher_greeting_message: values.voucher_greeting_message || undefined,
    recipient_email: values.recipient_email || undefined,
    delivery_date: values.delivery_date || undefined,
    delivery_time: values.delivery_time || undefined,
    should_send_delayed: values.should_send_delayed,
    manual_resource_holds: values.selectedHolds.length > 0 ? values.selectedHolds : undefined,
    course_id: getCourseId(availableDatesForEvents, values.date, values.timeSeconds),
    deposit_price: depositPrice,
    create_payment_link: values.createPaymentLink,
    pending_expires_at: values.createPaymentLink
      ? holdExpiryIso(values.paymentLinkHoldDate, values.paymentLinkHoldTime, account.timezone)
      : undefined,
  };
};
